export enum TQStatus {
  Draft = 0,
  Sent = 1,
  Answered = 2,
  NeedFurtherClarification = 3,
  Closed = 4,
  FullyAnswered = 5,
  Cancelled = 6,
  ReadyForReview = 7,
  NeedFurtherClarificationSent = 8,
}

export const TQStatusMetadata: {
  [key in TQStatus]: { description: string; style: string; order: number; hidden: boolean };
} = {
  [TQStatus.Draft]: { description: 'Draft', style: 'badge-secondary', order: 0, hidden: true },
  [TQStatus.Sent]: { description: 'Sent', style: 'badge-primary', order: 2, hidden: false },
  [TQStatus.Answered]: { description: 'Answered', style: 'badge-success', order: 3, hidden: false },
  [TQStatus.NeedFurtherClarification]: {
    description: 'Needs Clarification',
    style: 'badge-primary',
    order: 4,
    hidden: false,
  },
  [TQStatus.Closed]: { description: 'Closed', style: 'badge-success', order: 7, hidden: false },
  [TQStatus.FullyAnswered]: { description: 'Fully Answered', style: 'badge-success', order: 6, hidden: false },
  [TQStatus.Cancelled]: { description: 'Cancelled', style: 'badge-light', order: 8, hidden: true },
  [TQStatus.ReadyForReview]: { description: 'Ready For Review', style: 'badge-info', order: 1, hidden: true },
  [TQStatus.NeedFurtherClarificationSent]: {
    description: 'Clarification Requested',
    style: 'badge-primary',
    order: 5,
    hidden: false,
  },
};

export const TQStatusSorted = Object.entries(TQStatusMetadata)
  .map(([key, value]) => ({
    status: Number(key) as TQStatus,
    ...value,
  }))
  .filter(x => !x.hidden)
  .sort((a, b) => a.order - b.order);
